export default __webpack_public_path__ + "chat-icon.ef44a9ae.svg";